import { supabase } from '../config/supabase';

/** Base URL for redirects (e.g. https://glonboarding.com). Set REACT_APP_APP_URL or we use window.location.origin. */
export function getAuthCallbackUrl(): string {
  const base =
    typeof process !== 'undefined' && process.env.REACT_APP_APP_URL
      ? process.env.REACT_APP_APP_URL
      : typeof window !== 'undefined'
        ? window.location.origin
        : '';
  return base ? `${base.replace(/\/$/, '')}/auth/callback` : '/auth/callback';
}

export const authService = {
  // Sign in with email and password using Supabase Auth
  async signIn(email: string, password: string) {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) throw error;
    // Optionally store session or user info as needed
    return data.user;
  },

  // Sign out
  async signOut() {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
  },

  // Get current session
  async getSession() {
    const { data, error } = await supabase.auth.getSession();
    if (error) throw error;
    return data.session;
  },

  // Get current user
  async getCurrentUser() {
    const { data, error } = await supabase.auth.getUser();
    if (error) throw error;
    return data.user;
  },

  // Sign up (optional, if you want to allow registration)
  async signUp(email: string, password: string) {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
    });
    if (error) throw error;
    return data.user;
  },

  // Sign in with magic link (email only, no password). Redirects to getAuthCallbackUrl() after user clicks link.
  async signInWithOtp(email: string) {
    const { data, error } = await supabase.auth.signInWithOtp({
      email,
      options: {
        emailRedirectTo: getAuthCallbackUrl(),
      },
    });
    if (error) throw error;
    return data;
  },

  // Request password reset
  async requestPasswordReset(email: string) {
    const { data, error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'https://www.glonboarding.com/reset-password',
    });
    if (error) throw error;
    return data;
  },

  // Reset password (handled by Supabase magic link, so you just need a form to set new password)
  async updateUserPassword(newPassword: string) {
    const { data, error } = await supabase.auth.updateUser({
      password: newPassword,
    });
    if (error) throw error;
    return data.user;
  },
}; 